//两位小数
export function clearNoNum(obj){
    obj = obj+''//一切转换为字符
    obj = obj.replace(/[^\d.]/g,"");  //清除“数字”和“.”以外的字符
    obj = obj.replace(/\.{2,}/g,"."); //只保留第一个. 清除多余的
    obj = obj.replace(".","$#$").replace(/\./g,"").replace("$#$",".");
    obj = obj.replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3');//只能输入两个小数
    if(obj.indexOf(".")< 0 && obj !=""){//以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
        obj= parseFloat(obj);
    }
    return obj
}

//不包含小数
export function clearNoNumWithInt(obj){
    obj = obj+''//一切转换为字符
    obj = obj.replace(/[^\d.]/g,"");  //清除“数字”和“.”以外的字符
    // obj = obj.replace(/\.{2,}/g,"."); //只保留第一个. 清除多余的
    // obj = obj.replace(".","$#$").replace(/\./g,"").replace("$#$",".");
    // obj = obj.replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3');//只能输入两个小数
    // if(obj.indexOf(".")< 0 && obj !=""){//以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
    //     obj= parseFloat(obj);
    // }
    return obj
}